import React from "react";
import aboutUs from "../../PicesForPages/JoinTheTeam.jpg";
import JoinTheTeamForm from "../Form/joinTheTeam";

function joinTheTeam() {
  return (
    <>
      <div className="purchaseParent">
        <div className="purchasetopParent">
          <img
            fetchPriority="high"
            loading="eager"
            src={aboutUs}
            alt="aboutUsImage"
            className="background-video aboutUsImage"
          />
          <div className="purchasetopBox">Join Our Family</div>
        </div>
        {/* <div className="joinTheTeamFormParent"> */}
        <div className="purchaseBottomParent">
          <div className="purchaseBottomBox joinTheTeamBottomBox">
            <div className="purchaseBottomLeftBox">
              {/* <span className="purchaseBottomLeftHeader">
                What can FHA offer you?
              </span>
              <span className="purchaseBottomLeftSubHeader">
                First-time homebuyer?
              </span> */}
              {/* <div className="purchaseBottomLeftHeader">Join The Team</div> */}

              <span className="purchaseBottomLeftContent">
                Join The Mortgageist as a mortgage loan officer and build a
                rewarding career with a team dedicated to empowering clients’
                homeownership journeys. Enjoy personalized mentorship,
                industry-leading expertise, and strong lender relationships that
                drive success. Experience a dynamic, innovative culture
                delivering growth opportunities and unrivaled support. Elevate
                your career even today.
              </span>
            </div>
            <JoinTheTeamForm />
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default joinTheTeam;
